import { BASIS_POINTS_DIVISOR } from '@ui/constants/uiConfig';
import TradingConfigFacet from '@ui/services/contract/abis/TradingConfigFacet';
import { getTradingConfigFacet } from '@ui/services/contract/contract-instances/getTradingConfigFacet';
import { ExtractReturn } from '@ui/services/contract/types/ExtractFunctionReturn';
import { Address } from '@ui/types/alias';
import { ChainId } from '@ui/types/chain';
import { PublicClient } from 'viem';

export type ContractPairMaxTpRatios = Readonly<
  ExtractReturn<typeof TradingConfigFacet, 'getPairMaxTpRatios'>[0]
>;

export const getPairMaxTpRatiosQuery = {
  getQueryKey: ({
    pairBase,
    clientUid,
  }: {
    pairBase: Address;
    clientUid: string;
  }) => ['TradingConfigFacet.getPairMaxTpRatios', pairBase, clientUid],
  getQueryFn:
    ({
      pairBase,
      client,
      chainId,
    }: {
      pairBase: Address;
      client?: PublicClient;
      chainId: ChainId;
    }) =>
    async () => {
      if (!client) {
        throw new Error('Client missing');
      }
      const result = await getTradingConfigFacet({
        publicClient: client,
        chainId,
      })?.read.getPairMaxTpRatios([pairBase]);

      return result.map((v) => {
        return {
          ...v,
          maxTakeProfitP: v.maxTakeProfitP / BASIS_POINTS_DIVISOR,
        };
      });
    },
};
